import * as React from 'react';
// import styles from './index.less';

interface FDragProps {
  className?: string;
  style?: React.CSSProperties;

  onClick?(): void;
}

function FDrag({className, ...props}: FDragProps) {
  return (<i className={['freelog', 'fl-icon-tuodong', className].join(' ')} {...props} />);
}

export default FDrag;
